import { NgModule } from '@angular/core';

import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import {canActivate, customClaims, redirectLoggedInTo, redirectUnauthorizedTo} from '@angular/fire/auth-guard';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

/*const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth/login']);
const redirectAuthorizedToHome = () => redirectLoggedInTo(['/']);*/


const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth/login']);
const redirectAuthorizedToHome = () => redirectLoggedInTo(['home']);

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./views/auth/auth.module').then( m => m.AuthPageModule),
    ...canActivate(redirectAuthorizedToHome),
  },
  {
    path: 'home',
    loadChildren: () => import('./views/home/home.module').then(m => m.HomePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'profile/:id',
    loadChildren: () => import('./views/profile/profile.module').then( m => m.ProfilePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./views/auth/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule),
    ...canActivate(redirectAuthorizedToHome)
  },
 
  {
    path: 'header',
    loadChildren: () => import('./views/header/header.module').then( m => m.HeaderPageModule)
  },
  {
    path: 'popover',
    loadChildren: () => import('./views/popover/popover.module').then( m => m.PopoverPageModule)
  },
  {
    path: 'user-setting',
    loadChildren: () => import('./views/user-setting/user-setting.module').then( m => m.UserSettingPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'user-account',
    loadChildren: () => import('./views/user-account/user-account.module').then( m => m.UserAccountPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'hospital/create',
    loadChildren: () => import('./views/hospital/create-hospital/create-hospital.module').then( m => m.CreateHospitalPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'notification-setting',
    loadChildren: () => import('./views/notification-setting/notification-setting.module').then( m => m.NotificationSettingPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./views/change-password/change-password.module').then( m => m.ChangePasswordPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'hospital/edit',
    loadChildren: () => import('./views/hospital/edit/edit.module').then( m => m.EditPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'hospitals',
    loadChildren: () => import('./views/hospital/view-hospitals/view-hospitals.module').then( m => m.ViewHospitalsPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'events',
    loadChildren: () => import('./views/event-page/event-page.module').then( m => m.EventPagePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'create-event',
    loadChildren: () => import('./views/create-event/create-event.module').then( m => m.CreateEventPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'test',
    loadChildren: () => import('./views/data-table/data-table/data-table.module').then( m => m.DataTablePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'users',
    loadChildren: () => import('./views/user/user.module').then( m => m.UserPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'edit-events',
    loadChildren: () => import('./views/edit-events/edit-events.module').then( m => m.EditEventsPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'messages',
    loadChildren: () => import('./views/messages/messages.module').then( m => m.MessagesPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'hospital/dashboard/:id',
    loadChildren: () => import('./views/hospital/dashboard/dashboard.module').then( m => m.DashboardPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./views/notifications/notifications.module').then( m => m.NotificationsPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'arterial',
    loadChildren: () => import('./views/products/product-dashboard/product-dashboard.module').then( m => m.ProductDashboardPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'category',
    loadChildren: () => import('./views/resource-library/category/category.module').then( m => m.CategoryPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'files',
    loadChildren: () => import('./views/resource-library/files/files.module').then( m => m.FilesPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'files/edit/:id',
    loadChildren: () => import('./views/resource-library/file-edit/file-edit.module').then( m => m.FileEditPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'files/add',
    loadChildren: () => import('./views/resource-library/file-edit/file-edit.module').then( m => m.FileEditPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'arterial/edit/:id',
    loadChildren: () => import('./views/products/product-insertion/product-insertion.module').then( m => m.ProductInsertionPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'arterial/new',
    loadChildren: () => import('./views/products/product-insertion/product-insertion.module').then( m => m.ProductInsertionPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'endurance',
    loadChildren: () => import('./views/products/endurance/endurance.module').then( m => m.EndurancePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'cvc',
    loadChildren: () => import('./views/products/cvc/cvc.module').then( m => m.CvcPageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
  {
    path: 'midlines',
    loadChildren: () => import('./views/products/mildlines/mildlines.module').then( m => m.MildlinesPageModule)
  },
  {
    path: 'g4-picc',
    loadChildren: () => import('./views/products/g4-picc/g4-picc.module').then( m => m.G4PiccPageModule)
  },
  {
    path: 'dlx-rhythm',
    loadChildren: () => import('./views/products/dlx-rhythm/dlx-rhythm.module').then( m => m.DlxRhythmPageModule)
  },
  {
    path: 'timeline',
    loadChildren: () => import('./views/timeline/timeline.module').then( m => m.TimelinePageModule)
  },
  {
    path: 'edit-timeline',
    loadChildren: () => import('./views/edit-timeline/edit-timeline.module').then( m => m.EditTimelinePageModule)
  },
  {
    path: 'global-settings',
    loadChildren: () => import('./views/global-settings/global-settings.module').then( m => m.GlobalSettingsPageModule)
  },
  {
    path: '**',
    loadChildren: () => import('./views/wrongpage/wrongpage.module').then( m => m.WrongpagePageModule),
    ...canActivate(redirectUnauthorizedToLogin)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
